import { AppMenuDto, CrudAction } from './app.model';

export const systemMenus = [
  {
    path: 'user-api-key',
    module: 'x/pg',
    iconClass: 'key',
    requiredPolicy: 'Systems.UserApiKey',
  },
  {
    path: 'report-builder',
    module: 'x/pg',
    iconClass: 'file',
    requiredPolicy: 'Systems.ReportBuilder',
    crudAction: {
      create: 'system/report-builder',
      update: 'system/report-builder',
    },
  },
  {
    path: 'settings',
    module: 'system',
    iconClass: 'control',
    requiredPolicy: 'Systems.Settings',
  },
] as AppMenuDto[];
